const parsePackageTime = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) {
    return numericValue < 100000000000 ? numericValue * 1000 : numericValue;
  }

  const dateValue = Date.parse(value);
  return Number.isNaN(dateValue) ? null : dateValue;
};

export const getPackageOnlineStatus = (startAt, endAt, now = Date.now()) => {
  const startTime = parsePackageTime(startAt);
  const endTime = parsePackageTime(endAt);

  if (startTime === null || endTime === null) return 0;

  return startTime <= now && now <= endTime ? 1 : 0;
};

export const withPackageOnlineStatus = (data) => {
  if (!data || typeof data !== "object") return data;

  const hasStartAt = Object.prototype.hasOwnProperty.call(data, "startAt");
  const hasEndAt = Object.prototype.hasOwnProperty.call(data, "endAt");
  if (!hasStartAt && !hasEndAt) return data;

  return {
    ...data,
    online: getPackageOnlineStatus(data.startAt, data.endAt),
  };
};
